module.exports = __webpack_public_path__ + "static/media/smart_contract.da793b47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pictures/smart_contract.svg
// module id = 51
// module chunks = 0